import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/icon_add.png'


const _withScopeId = n => (_pushScopeId("data-v-1ddf7404"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-list" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx, _cache) {
  const _component_a_tag = _resolveComponent("a-tag")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["user-content", _ctx.isError ? 'is-error': ''])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "请选择"))
          : (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              closable: "",
              color: "blue",
              onClose: _withModifiers(_ctx.removeSelected, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.valueName), 1)
              ]),
              _: 1
            }, 8, ["onClose"]))
      ]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showModal && _ctx.showModal(...args))),
        class: "add-icon"
      }, _hoisted_4),
      (!_ctx.valueName?.length>0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "zhezhao",
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}